import React from "react";
import TypeAnimation from "react-type-animation";
import lasyanga from "./Hermingildo_Jr_Resume.pdf";


function Resume() {
  return (
    <>
      <a href={lasyanga} download="Herminigildo Jr Quiano-Resume.pdf">
        <button className="resume roboto-mono">
          <span className="type-green">\&#62;</span>&nbsp;
          <TypeAnimation
            cursor={false}
            sequence={["", 2000, "Get Resume", 3000]}
            wrapper="span"
          />
        </button>
      </a>
    </>
  );
}

export default Resume;
